export enum ListKeys {
  MONO_APP_REF = 'mfo_fd_restricted_page_web',
  CRM = 'crm',
  LIST = 'list',
  ONLINE = 'online',
  PROMOTION = 'promotion',
  LANDING = 'landing',
  LEADSSU = 'leadssu_promo',
  GURULEADS = 'guruleads_promo',
  BRANDING = 'branding',
  CALCULATOR = 'calculator',
  BESTPRODUCTS = 'best_products',
  BESTOFFERS = 'best_offers',
  NOVINKI = 'novinki',
  MOBILE_POPUP = 'mobile_popup',
  PARTNERS = 'partners',
  WL_PAGE = 'wl_app',
  WL_DENIED_PAGE = 'wl_denied_app',
  SIDEBAR_BANNER = 'sidebar_banner',
  SPEC_OFFERS = 'spec_offers',
  ZAIMY_POD_PTS = 'zaimy-pod-pts',
  KAZAKHSTAN = 'kazakhstan',
  NEW_SPECIAL = 'new_special',
  MFO_PARTNER_2GIS = 'mfo-partner-2gis',
  SPEC_OFFERS_BY_IDS = 'spec_offers_by_ids',
  FULL_DEAL_AND_PING3_OFFERS = 'full_deal_and_ping3_offers',
  DLYA_BANKROTOV = 'dlya-bankrotov',
  INOSTRANCAM = 'inostrancam',
}
